import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import token from './modules/token'
import keep from './modules/keep'
import searchCondition from './modules/searchCondition'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    token,
    keep,
    searchCondition
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js